import { MIN_BILLING_YEAR } from "../consts/billing";
import { ISelectOption } from "../types/select";

const lastYears: ISelectOption[] = [];

let currentYear = new Date().getFullYear();

while (currentYear >= MIN_BILLING_YEAR) {
  lastYears.push({ value: Number(currentYear), label: String(currentYear) });
  currentYear--;
}

export { lastYears, MIN_BILLING_YEAR };

export const getNextYears = (sinceYear: number, numberOfYears: number): ISelectOption[] => {
  const years: ISelectOption[] = [];

  while (years.length < numberOfYears) {
    years.push({ value: Number(sinceYear), label: String(sinceYear) });
    sinceYear++;
  }

  return years;
};
